import ToggleTeaser from './ToggleTeaser';

export default ToggleTeaser;
